import { useEffect, useState } from 'react';

const globalFonts = [
    {
        family: 'ChakraPetchTitle',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: 'bold',
            style: 'normal',
        },
    },
    {
        family: 'ChakraPetch',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Light.ttf') format('truetype')`,
        descriptors: {
            weight: '300',
            style: 'normal',
        },
    },
    {
        family: 'ChakraPetch',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Regular.ttf') format('truetype')`,
        descriptors: {
            weight: 'normal',
            style: 'normal',
        },
    },
    {
        family: 'ChakraPetch',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: '500',
            style: 'normal',
        },
    },
    {
        family: 'Inter',
        source: `url('/assets/global/typography/inter/Inter-Regular.ttf') format('truetype')`,
        descriptors: {
            weight: '400',
            style: 'normal',
        },
    },
    {
        family: 'Inter',
        source: `url('/assets/global/typography/inter/Inter-SemiBold.ttf') format('truetype')`,
        descriptors: {
            weight: '500',
            style: 'normal',
        },
    },
    {
        family: 'Inter',
        source: `url('/assets/global/typography/inter/Inter-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: 'bold',
            style: 'normal',
        },
    },
];

export default function useFontLoader() {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const fontlist = globalFonts;
        const fontPromises = fontlist.map((font) => {
            return new Promise<void>((resolve) => {
                const newFont = new FontFace(font.family, font.source, font.descriptors);
                newFont
                    .load()
                    .then((loadedFont) => {
                        document.fonts.add(loadedFont);
                        resolve();
                    })
                    .catch((error) => {
                        console.error('Failed to load font', error);
                        resolve();
                    });
            });
        });

        Promise.all(fontPromises).then(() => {
            setReady(true);
        });
    }, []);

    return {
        ready,
    };
}
